import axios from 'axios';
import { createMutation, createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';
import { ItemsQuery } from '@/types/ItemsQuery';

import {
    ItemsSelectionQueryVariables,
    ItemsSelectionResponse,
    NamingPatterns,
    RunExportRequestPayload
} from './export-media-asset.types';

const useCreateSelection = createMutation({
    mutationFn: async ({ primaryKeys }: { primaryKeys: string[] | { itemsQuery: ItemsQuery } }) => {
        const selection = Array.isArray(primaryKeys) ? { primaryKeys } : primaryKeys;
        const response = await axios.post(restUrl('selections'), selection);

        return response.data;
    }
});

const useRunExport = createMutation({
    mutationFn: async ({ payload }: { payload: RunExportRequestPayload }) => {
        const response = await axios.post(restUrl('mediaAssets/export'), { ...payload });

        return response.data;
    }
});

const useNamingPatterns = createQuery<NamingPatterns>({
    queryKey: ['mediaAssets/namingPatterns'],
    fetcher: async () => {
        return axios.get(restUrl('mediaAssets/namingPatterns')).then(response => response.data);
    }
});

const useSelectedItems = createQuery<ItemsSelectionResponse, ItemsSelectionQueryVariables>({
    queryKey: ['mediaAssets/selected'],
    fetcher: async (variables) => {
        return axios.get(`${restUrl('mediaAssets/selected')}/${variables.selectionId}`)
            .then(response => response.data);
    }
});

export { useCreateSelection, useNamingPatterns, useRunExport, useSelectedItems };
